{
    "Accessibility menu": "Menu Aksesibilitas",
    "Close": "Tutup",
    "Text and Reading": "Teks dan membaca",
    "Navigation and Interaction": "Navigasi dan interaksi",
    "Text Align": "Perataan Teks",
    "Align Left": "Rata Kiri",
    "Align Center": "Rata Tengah",
    "Align Right": "Rata Kanan",
    "Adjust Font Size": "Sesuaikan Ukuran Font",
    "Highlight Title": "Sorot Judul",
    "Highlight Links": "Sorot Tautan",
    "Readable Font": "Font Mudah Dibaca",
    "Color and Contrast": "Warna dan kontras",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Tools": "Alat",
    "Reading Guide": "Panduan Membaca",
    "Big Cursor": "Kursor Besar",
    "Increase Font Size": "Perbesar Ukuran Font",
    "Decrease Font Size": "Perkecil Ukuran Font",
    "Letter Spacing": "Jarak Huruf",
    "Line Height": "Tinggi Baris",
    "Font Weight": "Ketebalan Font",
    "Dyslexia Font": "Font Disleksia",
    "Language": "Bahasa",
    "Accessibility widget": "Buka menu aksesibilitas",
    "Accessibility Profiles": "Profil Aksesibilitas",
    "Cognitive Disability": "Disabilitas Kognitif",
    "Seizure Safe": "Aman untuk Epilepsi",
    "Accessibility statement": "Pernyataan Aksesibilitas",
    "ADHD": "ADHD",
    "Low Vision": "Penglihatan Rendah",
    "Pause Animations": "Hentikan Animasi",
    "Animation paused": "Animasi dijeda",
    "Reset all settings": "Atur Ulang Pengaturan",
    "Shortcut:": "Pintasan:",
    "Epilepsy Safe Mode": "Mode Aman Epilepsi",
    "Mute sounds": "Bisukan suara",
    "Page read": "Baca halaman",
    "Page read controls": "Kontrol baca halaman",
    "Pause": "Jeda",
    "Resume": "Lanjutkan",
    "Stop": "Berhenti",
    "Settings": "Pengaturan",
    "Speed": "Kecepatan",
    "Voice": "Suara",
    "Close accessibility menu": "Tutup menu aksesibilitas",
    "Back to accessibility menu": "Kembali ke menu aksesibilitas",
    "Search languages": "Cari bahasa",
    "Selected language": "Bahasa yang dipilih",
    "View accessibility statement (opens in new window)": "Lihat pernyataan aksesibilitas (terbuka di jendela baru)",
    "Visit CookieYes website (opens in new window)": "Kunjungi situs web CookieYes (terbuka di jendela baru)",
    "Reset all accessibility settings to default": "Setel ulang semua pengaturan aksesibilitas ke default"
}
